export default __webpack_public_path__ + "static/media/icon-edit.fd4e94b1.svg";